import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/sources'

class SourceDataService extends RestApiDataService {
  all (filter = {}) {
    return this.getCustomItems('all', filter)
  }
}

export default new SourceDataService(BASE_ENTITY_URL)
